import { useSearchParams } from 'react-router-dom'
import { EndpointQueryParameters } from '../../types/strapi/strapi'
import qs from 'qs'

const deserializeStandardPagination = (
    paginationString: string
): EndpointQueryParameters['pagination'] => {
    const pagination: Partial<EndpointQueryParameters['pagination']> = qs.parse(paginationString)

    return {
        page: pagination.page ? Number(pagination.page) : 1,
        pageSize: pagination.pageSize ? Number(pagination.pageSize) : 15,
    }
}

export default function useEndpointQueryParams({
    deserializeFilters,
    deserializePagination = deserializeStandardPagination,
}: Settings): EndpointQueryParameters {
    const [searchParams] = useSearchParams()
    const filtersString = searchParams.get('filters') || ''
    const filtersParams = deserializeFilters(filtersString)
    const paginationString = searchParams.get('pagination') || ''
    const paginationParams = deserializePagination(paginationString)

    return {
        filters: filtersParams,
        pagination: paginationParams,
    }
}

interface Settings {
    deserializeFilters: DeserializeFilters
    deserializePagination?: DeserializePagination
}

export type DeserializeFilters = (filters: string) => EndpointQueryParameters['filters']
export type DeserializePagination = (pagination: string) => EndpointQueryParameters['pagination']
